export default __webpack_public_path__ + "static/media/el2.8ca31671.svg";